import { request3 } from '../../utils/request'
import { urlStringify } from '../../utils/index'

export const addmemberscorerule = option =>
  request3('v1/member/addmemberscorerule', option, true, false) // 新增规则

export const getnotsetedmemberscoretypes = option =>
  request3('v1/member/getnotsetedmemberscoretypes', option, true, false) // 获取规则下拉框

export const updatememberscorerule = option =>
  request3('v1/member/updatememberscorerule', option, true, false) // 修改规则

export const enablememberscorerule = option => {
  const urls = urlStringify(option)
  return request3('v1/member/enablememberscorerule' + urls, {}, true, false)
} // 启用规则

export const disenablememberscorerule = option => {
  const urls = urlStringify(option)
  return request3('v1/member/disenablememberscorerule' + urls, {}, true, false)
} // 关闭规则

export const getmemberscorerules = option =>
  request3('v1/member/getmemberscorerules', option, true, false) // 获取规则列表

export const addmemberlevel = option =>
  request3('v1/member/addmemberlevel', option, true, false) // 新增会员等级

export const updatememberlevel = option =>
  request3('v1/member/updatememberlevel', option, true, false) // 修改会员等级

export const deletememberlevel = option => {
  const urls = urlStringify(option)
  return request3('v1/member/deletememberlevel' + urls, {}, true, false)
} // 删除会员等级

export const getmemberleveltemplate = option => {
  const urls = urlStringify(option)
  return request3('v1/member/getmemberleveltemplate' + urls, {}, true, false)
} // 新增会员等级

export const creatememberlevelfromtemplate = option => {
  const urls = urlStringify(option)
  return request3(
    'v1/member/creatememberlevelfromtemplate' + urls,
    {},
    true,
    false
  )
} // 创建会员模板

export const getmemberlevels = option =>
  request3('v1/member/getmemberlevels', option, true, false) // 获取等级列表

export default {
  // 客户列表
  getmyusers: option => {
    return request3('v1/user/getmyusers', option, true)
  },
  // 下载用户到excel
  downloadusers: options => {
    const urls = urlStringify(options)
    return request3('v1/user/downloadusers' + urls, {}, true, false, true)
  },
  // 客户积分详情列表
  getpointsdetails: option => {
    return request3('v1/points/getpointsdetails', option, true)
  },
  // 客户详情
  getuser: option => {
    const urls = urlStringify(option)
    return request3('v1/user/getuser' + urls, {}, true)
  },
  // 查询收件人地址列表
  getdeliveryaddresses: options => {
    return request3('v1/deliveryaddress/getdeliveryaddresses', options, true)
  },
  // 新增规则
  addmemberscorerule: option =>
    request3('v1/member/addmemberscorerule', option, true),
  // 获取规则下拉框
  getnotsetedmemberscoretypes: option =>
    request3('v1/member/getnotsetedmemberscoretypes', option, true),
  // 修改规则
  updatememberscorerule: option =>
    request3('v1/member/updatememberscorerule', option, true),
  // 启用规则
  enablememberscorerule: option => {
    const urls = urlStringify(option)
    return request3('v1/member/enablememberscorerule' + urls, {}, true)
  },
  // 关闭规则
  disenablememberscorerule: option => {
    const urls = urlStringify(option)
    return request3('v1/member/disenablememberscorerule' + urls, {}, true)
  },
  // 获取规则列表
  getmemberscorerules: option =>
    request3('v1/member/getmemberscorerules', option, true),
  // 新增会员等级
  addmemberlevel: option => request3('v1/member/addmemberlevel', option, true),
  // 修改会员等级
  updatememberlevel: option =>
    request3('v1/member/updatememberlevel', option, true),
  // 删除会员等级
  deletememberlevel: option => {
    const urls = urlStringify(option)
    return request3('v1/member/deletememberlevel' + urls, {}, true)
  },
  // 获取会员模板
  getmemberleveltemplate: option => {
    const urls = urlStringify(option)
    return request3('v1/member/getmemberleveltemplate' + urls, {}, true)
  },
  // 创建会员模板
  creatememberlevelfromtemplate: option => {
    const urls = urlStringify(option)
    return request3('v1/member/creatememberlevelfromtemplate' + urls, {}, true)
  },
  // 获取等级列表
  getmemberlevels: option => request3('v1/member/getmemberlevels', option, true),
  //  小程序用户设置为员工
  bindstaff: option => {
    const urls = urlStringify(option)
    return request3('v1/user/bindstaff' + urls, {}, true)
  },
  wxupdateuser: option => request3('v1/user/wxupdateuser', option, true)
}
